import { Lightning } from '@lightningjs/sdk';
import AutoscrollShader from './autoscroll.shader';

export class Autoscroll extends Lightning.Component {
  static _template() {
    return {
      rtt: true,
      shader: {
        type: AutoscrollShader,
        top: 1,
      },
      Text: {
        text: {
          wordWrap: false,
          textOverflow: false,
        },
      },
    };
  }

  _attach() {
    this._direction = -1;
    this.tag('Text').on('txLoaded', () => {
      this._updateInitialPosition();
    });
  }

  _detach() {
    this.tag('Text').removeAllListeners('txLoaded');
    this._cleanupTransition();
    this._animation = null;
  }

  set font(value) {
    this.patch({
      Text: { text: { ...value } },
      h: (value && value.lineHeight) || 0,
    });
  }

  set caption(value) {
    this.tag('Text').text.text = value;
  }

  _cleanupTransition() {
    const transition = this.tag('Text').transition('x');
    if (transition) {
      transition.stop();
      transition.removeAllListeners('progress');
      transition.removeAllListeners('finish');
    }
  }

  _scroll() {
    const text = this.tag('Text');
    // t = S / v, here v = 16 pixels per second.
    const duration = (text.finalW - this.finalW) / 16;

    text.setSmooth('x', this._direction === -1 ? this.finalW - text.finalW : 0, {
      timingFunction: 'linear',
      delay: 1,
      duration,
    });
  }

  _updateInitialPosition() {
    const text = this.tag('Text');
    if (text.finalW <= this.finalW) {
      text.x = Math.round((this.finalW - text.finalW) / 2);
      this._cleanupTransition();

      return;
    }

    text.x = 0;

    this._cleanupTransition();
    text.transition('x').on('progress', v => {
      const offset = 0.22;

      if (this._direction === -1) {
        this.shader.bottom = 1 - Math.max(v - 1 + offset, 0) / offset;
        this.shader.top = Math.min(1 - offset + v, 1);
      } else {
        this.shader.top = 1 - Math.max(v - 1 + offset, 0) / offset;
        this.shader.bottom = Math.min(1 - offset + v, 1);
      }
    });
    text.transition('x').on('finish', () => {
      this._direction = this._direction === -1 ? 1 : -1;
      this._scroll();
    });
    this._scroll();
  }
}
